import { render, staticRenderFns } from "./WinnerEditModal.vue?vue&type=template&id=2cbd31fd&scoped=true&"
import script from "./WinnerEditModal.vue?vue&type=script&lang=js&"
export * from "./WinnerEditModal.vue?vue&type=script&lang=js&"
import style0 from "./WinnerEditModal.vue?vue&type=style&index=0&id=2cbd31fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd31fd",
  null
  
)

export default component.exports